module.exports = __webpack_public_path__ + "img/img3.457827a6.png";